import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Link} from 'react-router-dom'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableFooter from '@material-ui/core/TableFooter'
import Paper from '@material-ui/core/Paper'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import MenuItem from '@material-ui/core/MenuItem';
import _ from 'lodash';
import moment from 'moment';
import qs from 'querystring';
import {reduxForm, formValueSelector} from 'redux-form'
import Slide from '@material-ui/core/Slide'
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import CopyToClipboard from 'react-copy-to-clipboard';
import ContentCopy from '@material-ui/icons/ContentCopy';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import DefaultCheckbox from '@material-ui/core/Checkbox';
import CreatableSelect from 'react-select/creatable';
import ErrorIcon from '@material-ui/icons/Error';
import Switch from '@material-ui/core/Switch';
import Pagination from '../../../../../uis/pagination'
import NoData from '../../../../../uis/noData'
import * as actions from '../reducers/list'
import * as copyActions from '../../order_copy/reducers/list'
import EnhancedFilterField from '../../../../../uis/enhancedFilterFiled';
import Text from '../../../../../uis/form/text';
import Textarea from '../../../../../uis/form/textarea';
import Number from '../../../../../uis/form/number';
import Select from '../../../../../uis/form/select'
import Datalist from '../../../../../uis/form/datalist'
import RadioForm from '../../../../../uis/form/radio'
import Datetime from '../../../../../uis/form/datetime'
import Checkbox from '../../../../../uis/form/checkbox'
import Upload from '../../../../../uis/form/upload'
import IdCardUpload from '../../../../../uis/form/idCardUpload'
import * as tip from '../../../../../uis/tip/reduces'
import dateFormat from '../../../../../util/dateFormat'
import * as http from '../../../../../util/http'
import {referDomains, languages} from '../../../../../util/consts'


const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    appBar: {
        position: 'relative',
    },
    flex: {
        flex: 1,
    },
    table: {
        minWidth: 700,
    },
    dialog: {
        maxWidth: 900
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: 1200,
        margin: '10px auto'
    },
    textField: {
        width: 300,
        margin: theme.spacing.unit * 2
    },
    doubleTextField: {
        width: (300 * 2) + (theme.spacing.unit * 4),
        margin: theme.spacing.unit * 2
    },
    dislogActions: {
        display: 'flex',
        justifyContent: 'space-around',
        margin: theme.spacing.unit * 3
    },
    contentCell: {
        maxWidth: 100,
        whiteSpace: 'noWrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    },
    tableCell: {
        padding: '4px 28px 4px 12px'
    },
    more: {
        display: 'inline-block',
        maxWidth: 100,
        whiteSpace: 'noWrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    },
    group: {
        margin: `${theme.spacing.unit}px 0`,
        flexDirection: 'row'
    },
    showMe: {
        marginLeft: theme.spacing.unit * 0
    },
    labels: {
        marginTop: 25
    },
})

const validate = values => {
    const errors = {}
    
    if (!values.aliwangwang) {
        errors.aliwangwang = '必填'
    }
    
    if (!values.phone) {
        errors.phone = '必填'
    } else if (!/^[0-9]*$/.test(values.phone)) {
        errors.phone = '只能是纯数字, 去掉+和空格';
    }
    
    if (!values.email) {
        errors.email = '必填'
    } else if (!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(values.email)) {
        errors.email = '格式不正确';
    }
   if (values.domain && values.domain.indexOf('www.') === 0) {
        errors.domain = '格式不正确, 不要带www';
    }
    if (values.isNeedBuyDomain  === undefined) {
        errors.isNeedBuyDomain = '必填'
    }

    // if (values.isNeedBuyDomain && (values.domainMoney === undefined || +values.domainMoney === 0)) {
    //     errors.domainMoney = '必填, 请填写真实的域名费用'
    // }
    
    // if (values.isNeedBuyDomain && !values.cidType) {
    //     errors.cidType = '必填'
    // }
    // if (values.isNeedBuyDomain && !values.attachmentUrl) {
    //     errors.attachmentUrl = '必填'
    // }

    if (!values.id && !values.paymentMethod) {
        errors.paymentMethod = '必填'
    }
    if (!values.buyYear) {
        errors.buyYear = '必填'
    }
    if (values.buyYear > 10) {
        errors.buyYear = '不能超过10年'
    }
      
    if (!values.orderTime) {
        errors.orderTime = '必填'
    }
    if (values.orderMoney === undefined) {
        errors.orderMoney = '必填'
    }
    if (!values.status) {
        errors.status = '必填'
    }
    if (values.isAuto  === undefined) {
        errors.isAuto = '必填'
    }
    if (!values.refundReason) {
        errors.refundReason = '必填';
    }
    if (values.refundMoney === undefined) {
        errors.refundMoney = '必填';
    } else if (values.status === '退款中' && +values.refundMoney === 0) {
        errors.refundMoney = '不能为空';
    }
    if (values.status === '退款中' && values.isNeedBuyDomain && values.isRefundDomain === false) {
        errors.isRefundDomain = '必填';
    }
    if (values.isRefundWangzhan === undefined) {
        errors.isRefundWangzhan = '必填';
    }
    if (!values.refundDuty) {
        errors.refundDuty = '必填';
    }
    return errors
}
const ftpValidate = values => {
    const errors = {}
    if (!values.domain) {
        errors.domain = '必填';
    }
    if (values.domain && values.domain.indexOf('www.') === 0) {
        errors.domain = '格式不正确, 不要带www';
    }
    if (!values.ftpType) {
        errors.ftpType = '必填';
    }
    if (!values.ftpServer) {
        errors.ftpServer = '必填';
    }
    if (!values.ftpName) {
        errors.ftpName = '必填';
    }
    if (!values.ftpPassword) {
        errors.ftpPassword = '必填';
    }
    if (!values.ftpPort) {
        errors.ftpPort = '必填';
    }

    return errors;
}

const sslValidate = values => {
    const errors = {}
    return errors;
}

const tempValidate = values => {
    const errors = {}
    return errors;
}

const translateValidate = values => {
    const errors = {}
    if (!values.tl) {
        errors.tl = '必填';
    }
    return errors;
}

const adminValidate = values => {
    const errors = {}
    return errors;
}

const delayValidate = values => {
    const errors = {}
    return errors;
}

const smsValidate = values => {
    const errors = {}
    return errors;
}

const asyncValidate = (values /*, dispatch */) => {
    return http.get(`/site-template/is-exist/${values.templateNumber}`)
        .then(data => {
            if (!data.data) {
                // eslint-disable-next-line
                throw { templateNumber: '不存在' }
            }
        })
}

const defaultLabels = [
    {label: "企业官网H5", value: "企业官网H5"}, 
    {label: "企业官网多语言", value: "企业官网多语言"},
    {label: "自备服务器", value: "自备服务器"},
]

function Transition(props) {
    return <Slide {...props} direction="up" />
}
class AddDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            labels: []
        }
    }
    handleStatus(e) {
        const {change} = this.props;
        if (e.target.value !== '新增') {
            change('isAuto', false)
        }
    }
    handleLabelsChange = (selectOptions) => {
        console.info(selectOptions);
        this.setState({
            labels: selectOptions ? [...selectOptions] : []
        }, () => {
            this.props.change('labels', (selectOptions || []).map(item => item.value).join(','))
        })
    }
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit, isNeedBuyDomain, change, status} = this.props
        
        return (<Dialog
            open={showModal.add || showModal.son}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullScreen
            TransitionComponent={Transition}
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton color="inherit" onClick={() => dispatch({type: actions.HIDE_MODAL})}>
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="title" color="inherit" className={classes.flex}>
                            新增模板建站订单
                        </Typography>
                        <Button color="inherit" type="submit" disabled={pristine || submitting}>
                            确定
                        </Button>
                    </Toolbar>
                </AppBar>
                <DialogContent className={classes.dialogContent}>
                    <Grid container spacing={8}>
                        <Grid item xs={4}>
                            <Text name="aliwangwang" label="客户旺旺号" placeholder="请输入客户旺旺号" className={classes.textField} required={true}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Text name="phone" label="客户手机号" placeholder="请输入客户手机号" className={classes.textField} required={true}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Text name="email" label="客户邮箱" placeholder="请输入客户邮箱" className={classes.textField} required={true}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Text name="companyName" label="公司名称" placeholder="请输入公司名称" className={classes.textField} required={false}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Select name="isNeedBuyDomain" label="是否需要购买域名" placeholder="请输入是否需要购买域名" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Text name="domain" label="客户域名" placeholder="请输入客户域名" className={classes.textField} required={false}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Number name="domainMoney" label="域名费用" placeholder="请查询域名费用后填写" className={classes.textField} required={false}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Select name="cidType" label="证件类型" placeholder="请输入证件类型" className={classes.textField} required={false} data={[{"name":"营业执照","value":"营业执照"},{"name":"身份证","value":"身份证"}]}/>
                        </Grid>
                        <Grid item xs={4}>
                            <IdCardUpload name="attachmentUrl" id="attachmentUrl" label="身份证或者营业执照" placeholder="请输入身份证或者营业执照" className={classes.textField} required={false}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Text name="templateNumber" label="模板编号" placeholder="请输入模板编号" className={classes.textField} required={true}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Select name="paymentMethod" label="付款方式" placeholder="请输入付款方式" className={classes.textField} required={true} data={[{"name":"线上淘宝","value":"线上淘宝"},{"name":"线下对公","value":"线下对公"},{"name":"线下微信","value":"线下微信"},{"name":"线下支付宝","value":"线下支付宝"}, {"name":"线上拼多多","value":"线上拼多多"}]}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Number name="orderMoney" label="已付款金额" placeholder="请输入已付款金额" className={classes.textField} required={true}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Number name="restOrderMoney" label="剩余订单金额" placeholder="请输入剩余订单金额" className={classes.textField} required={true}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Number name="buyYear" label="购买年限" placeholder="请输入购买年限" className={classes.textField} required={true}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Datetime name="orderTime" label="下单日期" placeholder="请输入下单日期" className={classes.textField} required={true}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Datetime name="decorationEndTime" type="datetime-local" label="装修交付日期" placeholder="请输入装修交付日期" className={classes.textField} required={false}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Upload name="customerInfoAttachmentUrl" id="customerInfoAttachmentUrl" label="客户资料附件" placeholder="客户资料附件" className={classes.textField} required={false}  onChange={() => change('decorationEndTime', dateFormat(new Date(Date.now() + (7 * 24 * 3600 * 1000)), 'yyyy-MM-ddTHH:mm'))}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Select name="status" label="状态" placeholder="请输入状态" className={classes.textField} required={true} data={[{"name":"待付款","value":"待付款"}, {"name":"授权码","value":"授权码"}, {"name":"续费","value":"续费"}, {"name":"多注册域名","value":"多注册域名"}, {"name":"更换套餐","value":"更换套餐"}, {"name":"新增","value":"新增"}]} onChange={(e) => this.handleStatus(e)}/>
                        </Grid>
                        {status === '新增' && <Grid item xs={4}>
                            <Select name="isAuto" label="是否软件自动" placeholder="请输入是否软件自动" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                        </Grid>}
                        {status === '新增' && <Grid item xs={4}>
                            <Select name="serverAddress" label="服务器地址" placeholder="请输入服务器地址" className={classes.textField} required={true} data={[{"name": "自动分配", "value": "自动分配"}, {"name": "cn2.jiaogeiwo.cn(广州)", "value": "cn2.jiaogeiwo.cn"}, {"name": "cn3.jiaogeiwo.cn(广州)", "value": "cn3.jiaogeiwo.cn"}, {"name": "cn4.jiaogeiwo.cn(广州)", "value": "cn4.jiaogeiwo.cn"}]} />
                        </Grid>}
                        <Grid item xs={4}>
                            <Select name="referDomain" label="订单来源" placeholder="请输入订单来源" className={classes.textField} required={false} data={referDomains} disabled={showModal.disabled}/>
                        </Grid>
                        <Grid item xs={4}>
                            <CreatableSelect
                                isMulti
                                placeholder={'请输入网站标签'}
                                value={this.state.labels}
                                onChange={this.handleLabelsChange}
                                options={defaultLabels}
                                className={classes.labels}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <Textarea name="preSaleRemarks" label="售前备注" placeholder="请输入售前备注" className={classes.textField} style={{width: "100%", marginLeft: 0, marginRight: 0}} required={false} disabled={showModal.disabled}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Textarea name="codingRemarks" label="开发备注" placeholder="一些客户明确提出来的，比如说指定栏目，指定模块，指定主题色这样的要求就写到这里面" className={classes.textField} style={{width: "100%", marginLeft: 0, marginRight: 0}} required={false} disabled={showModal.disabled}/>
                        </Grid>
                    </Grid>
                </DialogContent>
            </form>
        </Dialog>)
    }
}
class UpdateDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            labels: (props.initialValues.labels ? props.initialValues.labels.split(',').map(item => ({value: item, label: item})) : [])
        }
    }
    handleLabelsChange = (selectOptions) => {
        console.info(selectOptions);
        this.setState({
            labels: selectOptions ? [...selectOptions] : []
        }, () => {
            this.props.change('labels', (selectOptions || []).map(item => item.value).join(','))
        })
    }
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit, isNeedBuyDomain, permissionMap, change, befores, techs, afters, initialValues} = this.props
        return (<Dialog
            open={showModal.update}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullScreen
            TransitionComponent={Transition}
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton color="inherit" onClick={() => dispatch({type: actions.HIDE_MODAL})}>
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="title" color="inherit" className={classes.flex}>
                        {showModal.disabled ? '查看' : '修改'}模板建站订单
                        </Typography>
                        {!showModal.disabled && <Button color="inherit" type="submit" disabled={pristine || submitting}>
                            确定
                        </Button>}
                    </Toolbar>
                </AppBar>
                <DialogContent className={classes.dialogContent}>
                    <Grid container spacing={8}>
                        <Grid item xs={4}>
                            <Text name="aliwangwang" label="客户旺旺号" placeholder="请输入客户旺旺号" className={classes.textField} required={true} disabled={showModal.disabled}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Text name="phone" label="客户手机号" placeholder="请输入客户手机号" className={classes.textField} required={true} disabled={showModal.disabled}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Text name="email" label="客户邮箱" placeholder="请输入客户邮箱" className={classes.textField} required={true} disabled={showModal.disabled}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Text name="companyName" label="公司名称" placeholder="请输入公司名称" className={classes.textField} required={false}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Select name="isNeedBuyDomain" label="是否需要购买域名" placeholder="请输入是否需要购买域名" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]} disabled={showModal.disabled}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Text name="domain" label="客户域名" placeholder="请输入客户域名" className={classes.textField} required={false} disabled={showModal.disabled}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Number name="domainMoney" label="域名费用" placeholder="请输入域名费用" className={classes.textField} required={false} disabled={showModal.disabled}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Select name="cidType" label="证件类型" placeholder="请输入证件类型" className={classes.textField} required={false} data={[{"name":"营业执照","value":"营业执照"},{"name":"身份证","value":"身份证"}]} disabled={showModal.disabled}/>
                        </Grid>
                        <Grid item xs={4}>
                            <IdCardUpload name="attachmentUrl" id="attachmentUrl" label="身份证或者营业执照" placeholder="请输入身份证或者营业执照" className={classes.textField} required={false} disabled={showModal.disabled}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Text name="templateNumber" label="模板编号" placeholder="请输入模板编号" className={classes.textField} required={true}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Select name="paymentMethod" label="付款方式" placeholder="请输入付款方式" className={classes.textField} required={false} data={[{"name":"线上淘宝","value":"线上淘宝"},{"name":"线下对公","value":"线下对公"},{"name":"线下微信","value":"线下微信"},{"name":"线下支付宝","value":"线下支付宝"}, {"name":"线上拼多多","value":"线上拼多多"}]}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Number name="orderMoney" label="已付款金额" placeholder="请输入已付款金额" className={classes.textField} required={true}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Number name="restOrderMoney" label="剩余订单金额" placeholder="请输入剩余订单金额" className={classes.textField} required={true} disabled={showModal.disabled}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Number name="buyYear" label="购买年限" placeholder="请输入购买年限" className={classes.textField} required={true}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Datetime name="orderTime" label="下单日期" placeholder="请输入下单日期" className={classes.textField} required={true}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Datetime name="decorationEndTime" type="datetime-local" label="装修交付日期" placeholder="请输入装修交付日期" className={classes.textField} required={false}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Upload name="customerInfoAttachmentUrl" id="customerInfoAttachmentUrl" label="客户资料附件" placeholder="客户资料附件" className={classes.textField} required={false} disabled={showModal.disabled} onChange={() => change('decorationEndTime', dateFormat(new Date(Date.now() + (7 * 24 * 3600 * 1000)), 'yyyy-MM-ddTHH:mm'))}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Select name="isAuto" label="是否软件自动" placeholder="请输入是否软件自动" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Select name="serverAddress" label="服务器地址" placeholder="请输入服务器地址" className={classes.textField} required={true} data={[{"name": "自动分配", "value": "自动分配"}, {"name": "cn2.jiaogeiwo.cn(广州)", "value": "cn2.jiaogeiwo.cn"}]} />
                        </Grid>
                        <Grid item xs={4}>
                            <Select name="referDomain" label="订单来源" placeholder="请输入订单来源" className={classes.textField} required={false} data={referDomains} disabled={showModal.disabled}/>
                        </Grid>
                        <Grid item xs={4}>
                            <CreatableSelect
                                isMulti
                                placeholder={'请输入网站标签'}
                                value={this.state.labels}
                                onChange={this.handleLabelsChange}
                                options={defaultLabels}
                                className={classes.labels}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Text name="gitUrl" label="git仓库地址" placeholder="请输入git仓库地址" className={classes.textField} disabled={showModal.disabled}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Select name="currentAccountName" label="技术人员" placeholder="请输入技术人员" className={classes.textField} data={techs.map(item=>({name: item.name, value: item.name}))} disabled={showModal.disabled} onChange={(e) => change('currentAccountId', techs.find(item=>item.name === e.target.value).id)}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Select name="afterSalerName" label="售后人员" placeholder="请输入售后人员" className={classes.textField} data={afters.map(item=>({name: item.name, value: item.name}))} disabled={showModal.disabled} onChange={(e) => change('afterSalerId', afters.find(item=>item.name === e.target.value).id)}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Text name="customerTempDomain" label="临时域名" placeholder="请输入客户临时域名" className={classes.textField} disabled={showModal.disabled}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Text name="customerAdminUrl" label="管理后台url" placeholder="请输入管理后台url" className={classes.textField} disabled={showModal.disabled}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Text name="customerAdminName" label="管理员用户名" placeholder="请输入管理员用户名" className={classes.textField} disabled={showModal.disabled}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Text name="customerAdminPassword" label="管理员密码" placeholder="请输入管理员密码" className={classes.textField} disabled={showModal.disabled}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Textarea name="preSaleRemarks" label="售前备注" placeholder="请输入售前备注" className={classes.textField} style={{width: "100%", marginLeft: 0, marginRight: 0}} required={false} disabled={showModal.disabled}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Textarea name="codingRemarks" label="开发备注" placeholder="请输入开发备注" className={classes.textField} style={{width: "100%", marginLeft: 0, marginRight: 0}} required={false} disabled={showModal.disabled}/>
                        </Grid>
                        {(http.isRoot() || http.isJuan()) && <Grid item xs={4}>
                            <Select name="accountName" label="售前人员" placeholder="请输入售前人员" className={classes.textField} data={befores.map(item=>({name: item.name, value: item.name}))} disabled={showModal.disabled} onChange={(e) => change('accountId', befores.find(item=>item.name === e.target.value).id)}/>
                        </Grid>}
                        {permissionMap['模板建站订单_退款'] ? <Grid item xs={4}>
                            <Select name="status" label="状态" placeholder="请输入状态" className={classes.textField} data={[
                                {"name":"待付款","value":"待付款"}, 
                                {"name":"授权码","value":"授权码"}, 
                                {"name":"续费","value":"续费"}, 
                                {"name":"多注册域名","value":"多注册域名"}, 
                                {"name":"更换套餐","value":"更换套餐"},
                                {"name":"新增","value":"新增"},
                                {"name":"域名注册中","value":"域名注册中"},
                                {"name":"域名模板注册中","value":"域名模板注册中"},
                                {"name":"等待模板初始化","value":"等待模板初始化"},
                                {"name":"建站中","value":"建站中"},
                                {"name":"等待域名解析","value":"等待域名解析"},
                                {"name":"等待域名所有人变更","value":"等待域名所有人变更"},
                                {"name":"等待装修","value":"等待装修"},
                                {"name":"装修中","value":"装修中"},
                                {"name":"等待验收","value":"等待验收"},
                                {"name":"等待交付","value":"等待交付"},
                                {"name":"装修对接中","value":"装修对接中"},
                                {"name":"完成","value":"完成"},
                                {"name":"退款中","value":"退款中"},
                                {"name":"退款审核","value":"退款审核"},
                                {"name":"退款完成","value":"退款完成"},
                                {"name":"过期未开发","value":"过期未开发"},
                                {"name":"错误","value":"错误"}
                                ]} disabled={showModal.disabled}/>
                        </Grid> : <Grid item xs={4}>
                            <Select name="status" label="状态" placeholder="请输入状态" className={classes.textField} data={[
                                {"name":"等待验收","value":"等待验收"},
                                {"name":"等待交付","value":"等待交付"},
                                {"name":"完成","value":"完成"},
                                {"name":"退款审核","value":"退款审核"}
                            ]} disabled={showModal.disabled}/>
                        </Grid>}
                        <Grid item xs={4}>
                            <Upload name="contractUrl" id="contractUrl" label="合同上传" placeholder="请输入合同上传" className={classes.textField} required={false} disabled={showModal.disabled}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Upload name="invoiceUrl" id="invoiceUrl" label="发票上传" placeholder="请输入发票上传" className={classes.textField} required={false} disabled={showModal.disabled}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Text name="invoiceUrl" label="发票链接" placeholder="请输入发票链接" className={classes.textField} required={false} disabled={showModal.disabled}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Select name="anliIsTuijian" label="是否案例推荐" placeholder="请输入是否案例推荐" className={classes.textField} required={false} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Text name="anliTitle" label="案例标题" placeholder="请输入案例标题" className={classes.textField} required={false}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Upload name="anliPcImgUrl" id="anliPcImgUrl" label="案例缩略图" placeholder="案例缩略图" className={classes.textField} required={false} />
                        </Grid>
                        <Grid item xs={4}>
                            <Select name="anliStar" label="案例星级" placeholder="请输入案例星级" className={classes.textField} required={false} data={[{"name":"5星","value":5},{"name":"4星","value":4},{"name":"3星","value":3},{"name":"2星","value":2},{"name":"1星","value":1},{"name":"0星","value":0}]}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Textarea name="anliKeywords" label="案例关键词" placeholder="请输入案例关键词" className={classes.textField} required={false}/>
                        </Grid>
                    </Grid>
                </DialogContent>
            </form>
        </Dialog>)
    }
}

class RefundDialog extends Component {
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit, isNeedBuyDomain, initialValues} = this.props
        return (<Dialog
            open={showModal.refund}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent}>
                    {isNeedBuyDomain && <Checkbox name="isRefundDomain" label="是否退款域名" className={classes.textField} required={true} />}
                    <Checkbox name="isRefundWangzhan" label="是否退款网站" className={classes.textField} required={true} />
                    <RadioForm name="refundDuty" label="退款责任人" style={{flexDirection: 'row'}} radioGroupStyle={{display: 'flex', alignItems: 'center'}} labelStyle={{paddingRight: 16}} required={true}>
                        <FormControlLabel value={initialValues.accountName} control={<Radio />} label={initialValues.accountName} />
                        <FormControlLabel value={initialValues.afterSalerName} control={<Radio />} label={initialValues.afterSalerName} />
                        <FormControlLabel value={initialValues.currentAccountName} control={<Radio />} label={initialValues.currentAccountName} />
                    </RadioForm>
                    <Number name="refundMoney" label="退款金额" placeholder="请输入退款金额" className={classes.textField} required={true}/>                   
                    <Textarea name="refundReason" label="退款原因" placeholder="请输入退款原因" className={classes.textField} required={true}/>
                    <Text name="status" label="状态" placeholder="退款中" className={classes.textField} readOnly={true}/>
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button type="submit" variant="outlined" color="primary" disabled={pristine || submitting}>确定</Button>
                </DialogActions>
            </form>
        </Dialog>)
    }
}

class DeleteDialog extends Component {
    render() {
        const {dispatch,showModal} = this.props
        return (<Dialog
            open={showModal.delete}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <DialogContent>确定删除吗？</DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                <Button variant="outlined" color="primary" onClick={() => dispatch(actions.remove(showModal.id))}>确定</Button>
            </DialogActions>
        </Dialog>)
    }
}

class FtpDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dirs: [{"name": "/", "value": "/"}]
        }
    }
    changeFtpType(e) {
        const {change, initialValues} = this.props;
        if (e.target.value !== '无') {
            change('ftpServer', e.target.value)
            change('ftpName', initialValues.customerAdminName)
            change('ftpPassword', initialValues.customerAdminPassword)
            change('ftpPort', 21);
            change('ftpRootDir', '');

            if (e.target.value === 'hk2.mengb123.com') { // 案例
                change('domain', initialValues.customerAdminName + '.anli.taobaowebsite.cn');
            }
        } else {
            change('ftpServer', '');
            change('ftpName', '');
            change('ftpPassword', '');
        }
    }
    changeFtpWay(e) {
        const {change} = this.props;
        if (e.target.value === 'ftp') {
            change('ftpPort', 21);
        }
        if (e.target.value === 'sftp') {
            change('ftpPort', 22);
        }
        if (e.target.value === 'rsync') {
            change('ftpName', 'root');
            change('ftpRootDir', '/www/wwwroot');
        }
    }
    testFtp() {
        const {ftpServer, ftpName, ftpPassword, ftpPort = 21, ftpPublishWay = 'ftp', initialValues, dispatch} = this.props;
        console.info(ftpServer, ftpName, ftpPassword, ftpPort, ftpPublishWay);
        const url = process.env.NODE_ENV === 'production' ? `http://${(initialValues.customerAdminUrl || '').replace(initialValues.customerAdminName + '.', '')}/api/ftp-ls` : `http://127.0.0.1:3333/api/ftp-ls`;
        return http.post(url, {ftpServer, ftpName, ftpPassword, ftpPort, ftpPublishWay})
            .then((data) => {
                console.info(data);
                dispatch(tip.success(`FTP连接成功！`));
                this.setState({
                    dirs: [{name: '/', value: '/'}, ...data.data.map(item => ({name: item, value: '/' + item}))]
                });
            })
    }
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit, initialValues, ftpServer, ftpName, ftpPassword} = this.props
        let ftps = [{"name":"阿里云备案服务器1","value":"cn1.xuansiwei.com"}, {"name":"阿里云备案服务器2","value":"cn3.xuansiwei.com"}, {"name":"腾讯云备案服务器","value":"cn2.xuansiwei.com"}, {"name":"香港企业官网服务器","value":"hk1.mengb123.com"}, {"name":"香港非企业官网服务器","value":"hk3.mengb123.com"}, {"name":"香港案例服务器","value":"hk2.mengb123.com"}, {"name":"美国服务器1","value":"us1.mengb123.com"}, {"name":"美国服务器2","value":"us2.mengb123.com"}, {"name":"自定义服务器","value":"无"}];
        let notFtps = [{"name":"美国服务器","value":"us1.mengb123.com"}, {"name":"美国服务器2","value":"us2.mengb123.com"}, {"name":"自定义服务器","value":"无"}]
        if ((initialValues.labels || '').indexOf('自备服务器') !== -1 ) {
            ftps = notFtps;
        }
        if (!(http.isRoot() || http.isJuan() || http.isXi())) {
            ftps = [{"name":"自定义服务器","value":"无"}];
        }
        return (<Dialog
            open={showModal.ftp}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
            maxWidth={'md'}
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent}>
                <Grid container spacing={8}>
                        <Grid item xs={6}>
                            <Select name="ftpType" label="选择发布的服务器" placeholder="请选择发布的服务器" className={classes.textField} required={true} data={ftps} onChange={(e) => this.changeFtpType(e)}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Select name="ftpPublishWay" label="选择发布方式" placeholder="请选择发布方式" className={classes.textField} required={true} data={[{"name": "ftp", "value": "ftp"},{"name": "sftp", "value": "sftp"},{"name": "rsync", "value": "rsync"}]} onChange={(e) => this.changeFtpWay(e)}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Text name="ftpServer" label="FTP地址（解析记录值）" placeholder="您的WEB站点的服务器地址" className={classes.textField} required={true}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Text name="ftpName" label="FTP用户名" placeholder="您的WEB站点的FTP用户名" className={classes.textField} required={true}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Text name="ftpPassword" label="FTP密码" placeholder="请输入您WEB站点的FTP密码" className={classes.textField} required={true}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Text name="ftpPort" label="FTP端口" placeholder="如果不清楚请勿更改" className={classes.textField} required={true}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Datalist name="ftpRootDir" label="网站根目录" placeholder="注意查看您的ftp存放网站内容的路径, 比如是www, htdocs之类的" className={classes.textField} data={this.state.dirs}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Text name="domain" label="域名" placeholder="输入域名，不带www" className={classes.textField} required={true}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Select name="ftpCdn" label="CDN" placeholder="请选择CDN地址" className={classes.textField} required={false} data={[{"name":"cdn.xuansiwei.com","value":"cdn.xuansiwei.com"}, {"name":"cdn.mengb123.com","value":"cdn.mengb123.com"}, {"name": "jiaogeiwo_cdn", "value": "jiaogeiwo_cdn"}]}/> 
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button variant="outlined" disabled={!(ftpServer && ftpName && ftpPassword)} onClick={() => this.testFtp()}>测试并加载ftp目录</Button>
                    {(http.isRoot() || http.isJuan()) && <Button type="submit" variant="outlined" color="primary" disabled={pristine || submitting}>确定</Button>}
                </DialogActions>
            </form>
        </Dialog>)
    }
}

class SslDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            verified: false,
            recordName: '',
            recordValue: '',
            sslKey: '',
            sslCert: ''
        }
    }
    verify(formData) {
        const url = process.env.NODE_ENV === 'production' ? `http://${(formData.customerAdminUrl || '').replace(formData.customerAdminName + '.', '')}/api/ssl/${formData.customerAdminName}` : `http://127.0.0.1:3333/api/ssl/${formData.customerAdminName}`;
        return http.post(url, {
            domain: formData.domain,
            customerTempDomain: formData.customerTempDomain,
            recordName: this.state.recordName,
            recordValue: this.state.recordValue
        })
        .then((data) => {
            this.setState({verified: true});
        })
    }
    addSsl(formData) {
        const {dispatch, initialValues} = this.props;
        const url = process.env.NODE_ENV === 'production' ? `http://${(formData.customerAdminUrl || '').replace(formData.customerAdminName + '.', '')}/api/ssl/${formData.customerAdminName}` : `http://127.0.0.1:3333/api/ssl/${formData.customerAdminName}`;
        return http.post(url, {
            domain: formData.domain,
            customerTempDomain: formData.customerTempDomain,
            recordName: this.state.recordName,
            recordValue: this.state.recordValue,
            sslKey: this.state.sslKey,
            sslCert: this.state.sslCert
        })
        .then((data) => {
            dispatch(actions.update({...initialValues, sslKey: this.state.sslKey, sslCert: this.state.sslCert}));
        });
    }
    render() {
        const {classes, dispatch, showModal, initialValues} = this.props;
        return (<Dialog
            open={showModal.ssl}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <DialogContent className={classes.dialogContent}>
                {initialValues.sslKey && <TextField
                        name="oldsslKey" 
                        label="历史私钥" 
                        placeholder="历史私钥" 
                        style={{width: '100%'}}
                        margin="normal"
                        value={initialValues.sslKey}
                        multiline={true}
                        rows={2}
                    />} 
                {initialValues.sslCert && <TextField
                        name="oldsslCert" 
                        label="历史证书" 
                        placeholder="历史证书" 
                        style={{width: '100%'}}
                        margin="normal"
                        value={initialValues.sslCert}
                        multiline={true}
                        rows={2}
                    />}
                <TextField
                    name="recordName" 
                    label="记录名" 
                    placeholder="文件验证记录名" 
                    style={{width: '100%'}} 
                    required={true}
                    margin="normal"
                    value={this.state.recordName}
                    onChange={(e) => this.setState({recordName: e.target.value})}
                />
                <TextField
                    name="recordValue" 
                    label="记录值" 
                    placeholder="文件验证记录值" 
                    style={{width: '100%'}} 
                    required={true}
                    margin="normal"
                    value={this.state.recordValue}
                    onChange={(e) => this.setState({recordValue: e.target.value})}
                    multiline={true} rows={3}
                />
                <Button type="button" variant="outlined" color="primary" onClick={() => this.verify(initialValues)}>点击验证</Button>
                {this.state.verified && <div>
                    <TextField
                        name="sslKey" 
                        label="私钥" 
                        placeholder="私钥" 
                        style={{width: '100%'}} 
                        required={true}
                        margin="normal"
                        value={this.state.sslKey}
                        onChange={(e) => this.setState({sslKey: e.target.value})}
                        multiline={true}
                        rows={5}
                    />
                    <TextField
                        name="sslCert" 
                        label="证书" 
                        placeholder="证书" 
                        style={{width: '100%'}} 
                        required={true}
                        margin="normal"
                        value={this.state.sslCert}
                        onChange={(e) => this.setState({sslCert: e.target.value})}
                        multiline={true}
                        rows={5}
                    />
                    <Button type="button" variant="outlined" color="primary" onClick={() => this.addSsl(initialValues)}>安装证书</Button>
                </div>}
            </DialogContent>
        </Dialog>)
    }
}

class TempDialog extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
    }
    render() {
        const {classes, dispatch, showModal, submitting, handleSubmit} = this.props
        return (<Dialog
            open={showModal.temp}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent}>
                    <Text name="newDomain" label="域名" placeholder="输入域名，不带www" className={classes.textField} required={true}/>
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button type="submit" variant="outlined" color="primary" disabled={submitting}>确定</Button>
                </DialogActions>
            </form>
        </Dialog>)
    }
}

class TranslateDialog extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
    }
    render() {
        const {classes, dispatch, showModal, submitting, handleSubmit} = this.props
        return (<Dialog
            open={showModal.translate}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent}>
                    <RadioForm name="type" label="类型" style={{flexDirection: 'row'}} radioGroupStyle={{display: 'flex', alignItems: 'center'}} labelStyle={{paddingRight: 16}}>
                        <FormControlLabel value='add' control={<Radio />} label="新增语言" />
                        <FormControlLabel value='update' control={<Radio />} label="修改默认语言" />
                    </RadioForm>
                    <Select name="tl" label="选择语言" placeholder="请选择语言" className={classes.textField} required={true} data={languages}/>
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button type="submit" variant="outlined" color="primary" disabled={submitting}>确定</Button>
                </DialogActions>
            </form>
        </Dialog>)
    }
}

class AdminDialog extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
    }
    render() {
        const {classes, dispatch, showModal, submitting, handleSubmit} = this.props
        return (<Dialog
            open={showModal.admin}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent}>
                    
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button type="submit" variant="outlined" color="primary" disabled={submitting}>确定</Button>
                </DialogActions>
            </form>
        </Dialog>)
    }
}

class FlowDialog extends Component {
    render() {
        const {dispatch,showModal, classes, flowDetail: {list}} = this.props
        return (<Dialog
            open={showModal.flow}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
            maxWidth={"md"}
            scroll={"paper"}
        >
            <DialogContent>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>执行人</TableCell>
                            <TableCell>执行时间</TableCell>
                            <TableCell>执行状态</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {list.map(row => {
                            return (
                                <TableRow key={row.id}>
                                    <TableCell>{row.optAccountName}</TableCell>
                                    <TableCell>{dateFormat(new Date(row.createTime))}</TableCell>
                                    <TableCell>{row.status}</TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </DialogContent>
        </Dialog>)
    }
}

class DelayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            phone: null,
            due_time: null,
            is_active: false,
            password: '',
            total_space_size: '',
        }
    }
    componentDidMount() {
        const {initialValues} = this.props;
        console.info(initialValues, this.props)
        const url = process.env.NODE_ENV === 'production' ? `http://${(initialValues.customerAdminUrl || '').replace(initialValues.customerAdminName + '.', '')}/api/get-site-data/${initialValues.customerAdminName}` : `http://127.0.0.1:3333/api/get-site-data/${initialValues.customerAdminName}`;
        return http.get(url)
        .then((data) => {
            console.info(data)
            this.setState({
                phone: data.account.phone,
                due_time: moment(data.account.due_time).format('YYYY-MM-DD'),
                is_active: !!data.account.is_active,
                total_space_size: data.current_site.total_space_size > 0 ? data.current_site.total_space_size  / (1024 * 1024) : '',
            });
        })
    }
    verify() {
        const {dispatch, initialValues} = this.props;
        const url = process.env.NODE_ENV === 'production' ? `http://${(initialValues.customerAdminUrl || '').replace(initialValues.customerAdminName + '.', '')}/api/set-due-time/${initialValues.customerAdminName}` : `http://127.0.0.1:3333/api/set-due-time/${initialValues.customerAdminName}`;
        return http.post(url, {
            phone: this.state.phone,
            due_time: this.state.due_time,
            is_active: this.state.is_active,
            password: this.state.password,
            server: initialValues.customerAdminUrl.split('.')[1],
            total_space_size: this.state.total_space_size * 1024 * 1024,
        })
        .then(() => {
            dispatch({type: actions.HIDE_MODAL});
        });
    }
    render() {
        const {classes, dispatch, showModal} = this.props;
        return (<Dialog
            open={showModal.delay}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <DialogContent className={classes.dialogContent} style={{margin: 'unset'}}>
                <p style={{margin: 0}}>
                    是否激活: 
                    <Switch checked={this.state.is_active} onChange={(e)=> this.setState({is_active: !this.state.is_active})} />
                </p>
                <TextField
                    type="text"
                    name="phone" 
                    label="手机号码" 
                    placeholder="网站绑定手机号码" 
                    InputLabelProps={{
                        shrink: true,
                    }}
                    style={{width: '100%'}} 
                    required={true}
                    margin="normal"
                    value={this.state.phone}
                    onChange={(e) => this.setState({phone: e.target.value})}
                />
                <TextField
                    type="date"
                    name="due_time" 
                    label="到期时间" 
                    placeholder="网站到期时间" 
                    InputLabelProps={{
                        shrink: true,
                    }}
                    style={{width: '100%'}} 
                    required={true}
                    margin="normal"
                    value={this.state.due_time}
                    onChange={(e) => this.setState({due_time: e.target.value})}
                />
                <TextField
                    type="text"
                    name="password" 
                    label="密码" 
                    placeholder="网站登录密码" 
                    InputLabelProps={{
                        shrink: true,
                    }}
                    style={{width: '100%'}} 
                    required={false}
                    margin="normal"
                    value={this.state.password}
                    onChange={(e) => this.setState({password: e.target.value})}
                />
                <TextField
                    type="number"
                    name="total_space_size" 
                    label="网站空间(GB)" 
                    placeholder="网站空间" 
                    InputLabelProps={{
                        shrink: true,
                    }}
                    style={{width: '100%'}} 
                    required={true}
                    margin="normal"
                    value={this.state.total_space_size}
                    onChange={(e) => this.setState({total_space_size: e.target.value})}
                />
                <Button type="button" variant="outlined" color="primary" onClick={() => this.verify()}>确定调整</Button>
            </DialogContent>
        </Dialog>)
    }
}

class SmsDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sms_china_size: 0,
            sms_global_size: 0,
        }
    }
    componentDidMount() {
        const {initialValues} = this.props;
        console.info(initialValues, this.props)
        const url = process.env.NODE_ENV === 'production' ? `http://${(initialValues.customerAdminUrl || '').replace(initialValues.customerAdminName + '.', '')}/api/sms/get/${initialValues.customerAdminName}` : `http://127.0.0.1:3333/api/sms/get/${initialValues.customerAdminName}`;
        return http.get(url)
        .then((data) => {
            console.info(data)
            this.setState({
                sms_china_size: data.sms_china_size,
                sms_global_size: data.sms_global_size,
            });
        })
    }
    verify() {
        const {dispatch, initialValues} = this.props;
        const url = process.env.NODE_ENV === 'production' ? `http://${(initialValues.customerAdminUrl || '').replace(initialValues.customerAdminName + '.', '')}/api/sms/set/${initialValues.customerAdminName}` : `http://127.0.0.1:3333/api/sms/set/${initialValues.customerAdminName}`;
        return http.post(url, {
            sms_china_size: this.state.sms_china_size,
            sms_global_size: this.state.sms_global_size,
        })
        .then(() => {
            dispatch({type: actions.HIDE_MODAL});
        });
    }
    render() {
        const {classes, dispatch, showModal} = this.props;
        return (<Dialog
            open={showModal.sms}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <DialogContent className={classes.dialogContent} style={{margin: 'unset'}}>
                <TextField
                    type="number"
                    name="sms_china_size" 
                    label="国内短信验证码100元1000条" 
                    placeholder="国内短信验证码100元1000条" 
                    InputLabelProps={{
                        shrink: true,
                    }}
                    style={{width: '100%'}} 
                    required={true}
                    margin="normal"
                    value={this.state.sms_china_size}
                    onChange={(e) => this.setState({sms_china_size: e.target.value})}
                />
                <TextField
                    type="number"
                    name="sms_global_size" 
                    label="国际短信验证码100元100条" 
                    placeholder="国际短信验证码100元100条" 
                    InputLabelProps={{
                        shrink: true,
                    }}
                    style={{width: '100%'}} 
                    required={true}
                    margin="normal"
                    value={this.state.sms_global_size}
                    onChange={(e) => this.setState({sms_global_size: e.target.value})}
                />
                <Button type="button" variant="outlined" color="primary" onClick={() => this.verify()}>确定调整</Button>
            </DialogContent>
        </Dialog>)
    }
}

class KeywordDialog extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
        this.state = {
            anliLanguages: (props.initialValues.anliLanguages ? props.initialValues.anliLanguages.split(',').map(item => ({value: item, label: item})) : []),
            anliWangzhanTypes: (props.initialValues.anliWangzhanTypes ? props.initialValues.anliWangzhanTypes.split(',').map(item => ({value: item, label: item})) : []),
            anliProductTypes: (props.initialValues.anliProductTypes ? props.initialValues.anliProductTypes.split(',').map(item => ({value: item, label: item})) : []),
            anliAreaCategorys: (props.initialValues.anliAreaCategorys ? props.initialValues.anliAreaCategorys.split(',').map(item => ({value: item, label: item})) : []),
            anliSecondAreaCategorys: (props.initialValues.anliSecondAreaCategorys ? props.initialValues.anliSecondAreaCategorys.split(',').map(item => ({value: item, label: item})) : []),
            anliContainProducts: (props.initialValues.anliContainProducts ? props.initialValues.anliContainProducts.split(',').map(item => ({value: item, label: item})) : []),
            anliLabels: (props.initialValues.anliLabels ? props.initialValues.anliLabels.split(',').map(item => ({value: item, label: item})) : []),
            anli_languages: [],
            anli_wangzhan_types: [],
            anli_product_types: [],
            anli_area_categorys: [],
            anli_second_area_categorys: [],
            anli_contain_products: [],
            anli_labels: [],
        };
        this.copyMyList = [];
    }
    changeOptions() {
        let anli_languages = {};
        let anli_wangzhan_types = {};
        let anli_product_types = {};
        let anli_area_categorys = {};
        let anli_second_area_categorys = {};
        let anli_contain_products = {};
        let anli_labels = {};
        function keywordFilter(item) {
            if (item.anliLanguages) {
                item.anliLanguages.split(',').forEach(a => {
                    if (!anli_languages[a]) {
                        anli_languages[a] = 1
                    } else {
                        anli_languages[a]++;
                    }
                })
            }
            if (item.anliWangzhanTypes) {
                item.anliWangzhanTypes.split(',').forEach(a => {
                    if (!anli_wangzhan_types[a]) {
                        anli_wangzhan_types[a] = 1
                    } else {
                        anli_wangzhan_types[a]++;
                    }
                })
            }
            if (item.anliProductTypes) {
                item.anliProductTypes.split(',').forEach(a => {
                    if (!anli_product_types[a]) {
                        anli_product_types[a] = 1
                    } else {
                        anli_product_types[a]++;
                    }
                })
            }
            if (item.anliAreaCategorys) {
                item.anliAreaCategorys.split(',').forEach(a => {
                    if (!anli_area_categorys[a]) {
                        anli_area_categorys[a] = 1
                    } else {
                        anli_area_categorys[a]++;
                    }
                })
            }
            if (item.anliSecondAreaCategorys) {
                item.anliSecondAreaCategorys.split(',').forEach(a => {
                    if (!anli_second_area_categorys[a]) {
                        anli_second_area_categorys[a] = 1
                    } else {
                        anli_second_area_categorys[a]++;
                    }
                })
            }
            if (item.anliContainProducts) {
                item.anliContainProducts.split(',').forEach(a => {
                    if (!anli_contain_products[a]) {
                        anli_contain_products[a] = 1
                    } else {
                        anli_contain_products[a]++;
                    }
                })
            }
            if (item.anliLabels) {
                item.anliLabels.split(',').forEach(a => {
                    if (!anli_labels[a]) {
                        anli_labels[a] = 1
                    } else {
                        anli_labels[a]++;
                    }
                })
            }
        }
        this.copyMyList.filter(item => { // 过滤掉不相关的关键词
            return !!item.anliKeywords
        }).forEach(item => {
            keywordFilter(item);
        });
        this.setState({
            anli_languages: _.orderBy(Object.keys(anli_languages).map(key => ({label: `${key}(${anli_languages[key]})`, value: key, size: anli_languages[key]})), ['size'], ['desc']),
            anli_wangzhan_types: _.orderBy(Object.keys(anli_wangzhan_types).map(key => ({label: `${key}(${anli_wangzhan_types[key]})`, value: key, size: anli_wangzhan_types[key]})), ['size'], ['desc']),
            anli_product_types: _.orderBy(Object.keys(anli_product_types).map(key => ({label: `${key}(${anli_product_types[key]})`, value: key, size: anli_product_types[key]})), ['size'], ['desc']),
            anli_area_categorys: _.orderBy(Object.keys(anli_area_categorys).map(key => ({label: `${key}(${anli_area_categorys[key]})`, value: key, size: anli_area_categorys[key]})), ['size'], ['desc']),
            anli_second_area_categorys: _.orderBy(Object.keys(anli_second_area_categorys).map(key => ({label: `${key}(${anli_second_area_categorys[key]})`, value: key, size: anli_second_area_categorys[key]})), ['size'], ['desc']),
            anli_contain_products: _.orderBy(Object.keys(anli_contain_products).map(key => ({label: `${key}(${anli_contain_products[key]})`, value: key, size: anli_contain_products[key]})), ['size'], ['desc']),
            anli_labels: _.orderBy(Object.keys(anli_labels).map(key => ({label: `${key}(${anli_labels[key]})`, value: key, size: anli_labels[key]})), ['size'], ['desc']),
        })
    }
    componentDidMount() {
        return Promise.all([
            http.post(`/order-copy/list?page=0&size=10000`, {
                "logic": "and",
                "filters": [{
                    "field": 'anliIsTuijian',
                    "operator": 'eq',
                    "value": true
                }]
            }),
            http.post(`/order-my/list?page=0&size=10000`, {
                "logic": "and",
                "filters": [{
                    "field": 'anliIsTuijian',
                    "operator": 'eq',
                    "value": true
                }]
            })
        ])
        .then(([copyData, myData]) => {
            console.info(copyData.data.list.length, myData.data.list.length);
            this.copyMyList = [...copyData.data.list, ...myData.data.list];
            this.changeOptions();
        });
    }
    handleChange(key, selectOptions) {
        console.info(key, selectOptions);
        this.setState({
            [key]: selectOptions ? [...selectOptions] : []
        }, () => {
            this.changeOptions();
            this.props.change(key, (selectOptions || []).map(item => item.value).join(','))
        })
    }
    render() {
        const {classes, dispatch, showModal, submitting, handleSubmit} = this.props
        return (<Dialog
            open={showModal.keyword}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
            maxWidth={'md'}
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent} style={{minHeight: 500}}>
                    <Grid container spacing={8}>
                            <Grid item xs={6}>
                                <CreatableSelect
                                    isMulti
                                    placeholder={'请输入网站语言'}
                                    value={this.state.anliLanguages}
                                    onChange={(value) => this.handleChange('anliLanguages', value)}
                                    options={this.state.anli_languages}
                                    className={classes.labels}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <CreatableSelect
                                    isMulti
                                    placeholder={'请输入网站类型'}
                                    value={this.state.anliWangzhanTypes}
                                    onChange={(value) => this.handleChange('anliWangzhanTypes', value)}
                                    options={this.state.anli_wangzhan_types}
                                    className={classes.labels}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <CreatableSelect
                                    isMulti
                                    placeholder={'请输入产品类型'}
                                    value={this.state.anliProductTypes}
                                    onChange={(value) => this.handleChange('anliProductTypes', value)}
                                    options={this.state.anli_product_types}
                                    className={classes.labels}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <CreatableSelect
                                    isMulti
                                    placeholder={'请输入行业一级分类'}
                                    value={this.state.anliAreaCategorys}
                                    onChange={(value) => this.handleChange('anliAreaCategorys', value)}
                                    options={this.state.anli_area_categorys}
                                    className={classes.labels}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <CreatableSelect
                                    isMulti
                                    placeholder={'请输入行业二级分类'}
                                    value={this.state.anliSecondAreaCategorys}
                                    onChange={(value) => this.handleChange('anliSecondAreaCategorys', value)}
                                    options={this.state.anli_second_area_categorys}
                                    className={classes.labels}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <CreatableSelect
                                    isMulti
                                    placeholder={'请输入包含产品'}
                                    value={this.state.anliContainProducts}
                                    onChange={(value) => this.handleChange('anliContainProducts', value)}
                                    options={this.state.anli_contain_products}
                                    className={classes.labels}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <CreatableSelect
                                    isMulti
                                    placeholder={'请输入案例标签'}
                                    value={this.state.anliLabels}
                                    onChange={(value) => this.handleChange('anliLabels', value)}
                                    options={this.state.anli_labels}
                                    className={classes.labels}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Select name="anliIsTuijian" label="是否案例推荐" placeholder="请输入是否案例推荐" style={{width: '100%'}} required={false} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>
                            </Grid>
                            <Grid item xs={6}>
                                <Select name="anliStar" label="案例星级" placeholder="请输入案例星级" style={{width: '100%'}} required={false} data={[{"name":"5星","value":5},{"name":"4星","value":4},{"name":"3星","value":3},{"name":"2星","value":2},{"name":"1星","value":1},{"name":"0星","value":0}]}/>
                            </Grid>
                            <Grid item xs={6}>
                                <Text name="anliTitle" label="案例标题" placeholder="请输入案例标题" style={{width: '100%'}} required={false}/>
                            </Grid>
                            <Grid item xs={6}>
                                <Textarea name="anliKeywords" label="案例关键词" placeholder="请输入案例关键词" style={{width: '100%'}} required={false}/>
                            </Grid>
                            <Grid item xs={6}>
                                <Upload name="anliPcImgUrl" id="anliPcImgUrl" label="案例缩略图" placeholder="案例缩略图" style={{width: '100%'}} required={false} />
                            </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button type="submit" variant="outlined" color="primary" disabled={submitting}>确定</Button>
                </DialogActions>
            </form>
        </Dialog>)
    }
}

const AddFormDialog = connect(
    state => {
        const selector = formValueSelector('orderMyAddForm')
        return {
            initialValues: {
                isAuto: false,
                orderTime: dateFormat(new Date(), 'yyyy-MM-dd'),
                sendEmailTime: dateFormat(new Date(Date.now() + (6 * 3600 * 1000)), 'yyyy-MM-ddTHH:mm'),
                isNeedDecoration: true,
                decorationEndTime: dateFormat(new Date(Date.now() + (30 * 24 * 3600 * 1000)), 'yyyy-MM-ddTHH:mm'),
                serverAddress: '自动分配',
                restOrderMoney: 0,
                referDomain: window.location.host,
                isNeedBuyDomain: false,
            },
            isNeedBuyDomain: selector(state, 'isNeedBuyDomain'),
            status: selector(state, 'status')
        }
    },
)(reduxForm({
    form: 'orderMyAddForm',
    validate,
    asyncValidate,
    asyncBlurFields: ['templateNumber']
})(AddDialog))

const SonFormDialog = connect(
    state => {
        const selector = formValueSelector('orderMySonForm')
        return {
            initialValues: {
                ...state.orderMy.son,
            },
            isNeedBuyDomain: selector(state, 'isNeedBuyDomain'),
            status: selector(state, 'status')
        }
    },
)(reduxForm({
    form: 'orderMySonForm',
    validate
})(AddDialog))

const UpdateFormDialog = connect(
    state => {
        const selector = formValueSelector('orderMyUpdateForm')
        return {
            initialValues: {
                ...state.orderMy.detail, 
                orderTime: dateFormat(new Date(state.orderMy.detail.orderTime), 'yyyy-MM-dd'), 
                decorationEndTime: dateFormat(new Date(state.orderMy.detail.decorationEndTime), 'yyyy-MM-ddTHH:mm')
            },
            permissionMap: state.auth.user.permissionMap,
            isNeedBuyDomain: selector(state, 'isNeedBuyDomain')
        }
    },
  )(reduxForm({
    form: 'orderMyUpdateForm',
    validate
})(UpdateDialog))

const RefundFormDialog = connect(
    state => {
        const selector = formValueSelector('orderMyRefundForm')
        return {
            initialValues: {
                ...state.orderMy.detail, 
                status: '退款中',
                isRefundWangzhan: true
            },
            isNeedBuyDomain: selector(state, 'isNeedBuyDomain')
        }
    },
  )(reduxForm({
    form: 'orderMyRefundForm',
    validate
})(RefundDialog))

const FtpFormDialog = connect(
    state => {
        const selector = formValueSelector('orderMyFtpForm')
        return {
            initialValues: {
                ...state.orderMy.detail,
            },
            ftpServer: selector(state, 'ftpServer'),
            ftpName: selector(state, 'ftpName'),
            ftpPassword: selector(state, 'ftpPassword'),
            ftpPort: selector(state, 'ftpPort'),
            ftpPublishWay: selector(state, 'ftpPublishWay'),
        }
    },
  )(reduxForm({
    form: 'orderMyFtpForm',
    validate: ftpValidate
})(FtpDialog))

const SslFormDialog = connect(
    state => {
        return {
            initialValues: {
                ...state.orderMy.detail,
            }
        }
    },
  )(reduxForm({
    form: 'orderMySSLForm',
    validate: sslValidate
})(SslDialog));

const TempFormDialog = connect(
    state => {
        return {
            initialValues: {
                ...state.orderMy.detail,
                newDomain: 'caihongjianzhan.com'
            }
        }
    },
  )(reduxForm({
    form: 'orderCopyTempForm',
    validate: tempValidate
})(TempDialog));

const TranslateFormDialog = connect(
    state => {
        return {
            initialValues: {
                ...state.orderMy.detail,
                type: 'add'
            }
        }
    },
  )(reduxForm({
    form: 'orderMyTranslateForm',
    validate: translateValidate
})(TranslateDialog));

const AdminFormDialog = connect(
    state => {
        return {
            initialValues: {
                ...state.orderMy.detail
            }
        }
    },
  )(reduxForm({
    form: 'orderMyAdminForm',
    validate: adminValidate
})(AdminDialog));

const DelayFormDialog = connect(
    state => {
        return {
            initialValues: {
                ...state.orderMy.detail
            }
        }
    },
  )(reduxForm({
    form: 'orderMyDelayForm',
    validate: delayValidate
})(DelayDialog));

const SmsFormDialog = connect(
    state => {
        return {
            initialValues: {
                ...state.orderMy.detail
            }
        }
    },
  )(reduxForm({
    form: 'orderMySmsForm',
    validate: smsValidate
})(SmsDialog));

const KeywordFormDialog = connect(
    state => {
        return {
            initialValues: {
                ...state.orderMy.detail
            }
        }
    },
  )(reduxForm({
    form: 'orderMyKeywordForm',
    validate: adminValidate
})(KeywordDialog));

class OrderMy extends Component {
    componentDidMount() {
        const {dispatch}  = this.props
        dispatch(actions.getList())
        dispatch(actions.getStatusDetail())
        dispatch(copyActions.getBefores())
        dispatch(copyActions.getTechs())
        dispatch(copyActions.getAfters())
    }
    onPageClick = (index) => {
        const {dispatch,page} = this.props
        dispatch({
            type: actions.CHANGE_PAGE,
            page: {...page, index}
        })
        dispatch(actions.getList())
    }
    onSortClick = (sort) => {
        const {dispatch,page} = this.props
        dispatch({
            type: actions.CHANGE_PAGE,
            page: {...page, sort}
        })
        dispatch(actions.getList())
    }
    handleFiltersClick = (value) => {
        const { dispatch,filterList } = this.props
        const valueItem = filterList.find(item=>item.value === value);
        valueItem.isShow = !valueItem.isShow;
        dispatch({type: actions.CHANGE_FILTER_LIST,value: _.clone(filterList)})
    }
    cancelFiltersClick = (value) => {
        const { dispatch, query } = this.props
        this.handleFiltersClick(value);
        if (query[value]) {
            dispatch({type: actions.CHANGE_QUERY, key: value, value: null})
            dispatch(actions.getList())
        }
    }
    changeQuery = (e,name) => {
        const {dispatch} = this.props;
        dispatch({type: actions.CHANGE_QUERY,key: name,value: e.target ? e.target.value : e})
        dispatch(actions.getList())
    }
    renderStatus = (row) => {
        const {dispatch} = this.props;
        return <span>
            <span style={{paddingRight: 8}}>{row.status}</span>
            {row.customerAdminName && <select value={row.status} onChange={e => dispatch(actions.update({...row, status: e.target.value}))} >
                <option value={''}>请选择</option>
                {
                    [
                        {"name":"装修中","value":"装修中"},
                        {"name":"等待验收","value":"等待验收"},
                        {"name":"等待交付","value":"等待交付"},
                        {"name":"装修对接中","value":"装修对接中"}
                    ].map(item => {
                        return <option value={item.value}>{item.name}</option>
                    })
                }
            </select>}
        </span>
    }
    renderOverdue = (row) => {
        const {dispatch} = this.props;
        return <span>
            <span style={{paddingRight: 8}}>{row.isOverdue ? '是' : '否'}</span>
            {(http.isRoot() || http.isShouQianRole()) && row.customerAdminName && <select value={row.isOverdue} onChange={e => e.target.value && dispatch(actions.update({...row, isOverdue: e.target.value === 'true'}))} >
                {
                    [
                        {"name":"是","value":true},
                        {"name":"否","value":false},
                    ].map(item => {
                        return <option value={item.value}>{item.name}</option>
                    })
                }
            </select>}
        </span>
    }
    renderChangeTech(row) {
        const {dispatch, techs} = this.props;
        return row.customerAdminName ? <span style={{paddingLeft: 8}}>
            <select value={row.currentAccountId} onChange={e => e.target.value && dispatch(actions.update({...row, currentAccountId: +e.target.value, currentAccountName: techs.find(item => item.id === +e.target.value).name}))} >
                {
                    techs.map(item => {
                        return <option value={item.id}>{item.name}</option>
                    })
                }
            </select>
        </span> : <span></span>
    }
    renderChangeAfter(row) {
        const {dispatch, afters} = this.props;
        return row.customerAdminName ? <span style={{paddingLeft: 8}}>
            <select value={row.afterSalerId} onChange={e => e.target.value && dispatch(actions.update({...row, afterSalerId: +e.target.value, afterSalerName: afters.find(item => item.id === +e.target.value).name}))} >
                {
                    afters.map(item => {
                        return <option value={item.id}>{item.name}</option>
                    })
                }
            </select>
        </span> : <span></span>
    }
    renderChangeJiaofuTime(row) {
        const {dispatch} = this.props;
        return row.customerAdminName ? <span style={{paddingLeft: 8}}>
            <input type="date" value={dateFormat(new Date(row.decorationEndTime), 'yyyy-MM-dd')} onChange={e => dispatch(actions.update({...row, decorationEndTime: `${e.target.value}T18:00`}))} />
        </span> : <span></span>;
    }
    domainTest(row) {
        const {dispatch} = this.props;
        return Promise.all([row.domain, `www.${row.domain}`, row.ftpServer].map(domain => fetch(`https://dns.alidns.com/resolve?name=${domain}&short=1&type=1`).then(res => res.json())))
            .then(([[ip1], [ip2], [ip3]]) => {
                console.info(ip1, ip2, ip3);
                let arr = [];
                if (!ip1) {arr.push(`${row.domain}域名未解析成功`)}
                if (!ip2) {arr.push(`www.${row.domain}域名未解析成功`)}
                if (ip1 && ip1 !== ip3) {arr.push(`${row.domain}域名解析的ip地址为: ${ip1}, 服务器的ip地址为: ${ip3}`)}
                if (ip2 && ip2 !== ip3) {arr.push(`${row.domain}域名解析的ip地址为: ${ip2}, 服务器的ip地址为: ${ip3}`)}
                if (arr.length > 0) {
                    dispatch(tip.error(arr.join('\n')));
                } else {
                    dispatch(tip.success(`域名解析成功，如果网站还是不能正常访问，请在网站后台的域名管理模块添加域名！`));
                }
            })
    }
    render() {
        const {classes, dispatch, list, page, total ,permissionMap, query, filterList, showModal, statusDeatial, techs, afters, baseInfo} = this.props
        return (
            <div>
                <Grid container spacing={8} alignItems="baseline" style={{justifyContent: 'space-between'}}>
                    <Grid item>
                        {permissionMap['模板建站订单_新增'] && <Button variant="outlined" color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'add'})}>新增</Button>}
                        <FormControlLabel
                            control={
                                <DefaultCheckbox
                                    checked={query.isOnlyShowMe}
                                    onChange={(e) => {
                                        this.changeQuery(!query.isOnlyShowMe, 'isOnlyShowMe');
                                        dispatch(actions.getStatusDetail())
                                    }}
                                    value={query.isOnlyShowMe}
                                />
                            }
                            className={classes.showMe}
                            label={"只显示与我相关"}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            select
                            label="选择筛选条件"
                            margin="normal"
                            style={{minWidth: 200}}
                            onChange={(event) => this.handleFiltersClick(event.target.value)}
                        >
                            {filterList.filter(item => !item.isShow).map((item, index) => {
                                return (
                                    <MenuItem
                                        key={index}
                                        value={item.value}
                                    >
                                        {item.name}
                                    </MenuItem>
                                );
                            })}
                        </TextField>
                    </Grid>
                </Grid>
                <Grid container spacing={8} alignItems="baseline">
                    {filterList.filter(item => item.isShow).map((item, index) => {
                        return (
                            <EnhancedFilterField
                                item={item}
                                value={query[item.value]}
                                key={index}
                                onHandleQuery={(e) => this.changeQuery(e, item.value)}
                                hideCancelBtn={item.hideCancelBtn}
                                onCancel={this.cancelFiltersClick}
                            />
                        );
                    })}
                </Grid>
                <Grid container spacing={8}>
                    <FormControl component="fieldset" className={classes.formControl}>
                        <RadioGroup
                            name="status"
                            className={classes.group}
                            value={query.status}
                            onChange={(e) => this.changeQuery(e,'status')}
                        >
                            <FormControlLabel value="" control={<Radio />} label={<p>全部<span style={{color: 'red'}}>（{statusDeatial['全部'] || 0}）</span></p>} />
                            {statusDeatial['待付款'] && <FormControlLabel value="待付款" control={<Radio />} label={<p>待付款<span style={{color: 'red'}}>（{statusDeatial['待付款']}）</span></p>} />}
                            {statusDeatial['授权码'] && <FormControlLabel value="授权码" control={<Radio />} label={<p>授权码<span style={{color: 'red'}}>（{statusDeatial['授权码']}）</span></p>} />}
                            {statusDeatial['续费'] && <FormControlLabel value="续费" control={<Radio />} label={<p>续费<span style={{color: 'red'}}>（{statusDeatial['续费']}）</span></p>} />}
                            {statusDeatial['装修'] && <FormControlLabel value="装修" control={<Radio />} label={<p>装修<span style={{color: 'red'}}>（{statusDeatial['装修']}）</span></p>} />}
                            {statusDeatial['多注册域名'] && <FormControlLabel value="多注册域名" control={<Radio />} label={<p>多注册域名<span style={{color: 'red'}}>（{statusDeatial['多注册域名']}）</span></p>} />}
                            {statusDeatial['更换套餐'] && <FormControlLabel value="更换套餐" control={<Radio />} label={<p>更换套餐<span style={{color: 'red'}}>（{statusDeatial['更换套餐']}）</span></p>} />}
                            {statusDeatial['新增'] && <FormControlLabel value="新增" control={<Radio />} label={<p>新增<span style={{color: 'red'}}>（{statusDeatial['新增']}）</span></p>} />}
                            {statusDeatial['域名注册中'] && <FormControlLabel value="域名注册中" control={<Radio />} label={<p>域名注册中<span style={{color: 'red'}}>（{statusDeatial['域名注册中']}）</span></p>} />}
                            {statusDeatial['域名模板注册中'] && <FormControlLabel value="域名模板注册中" control={<Radio />} label={<p>域名模板注册中<span style={{color: 'red'}}>（{statusDeatial['域名模板注册中']}）</span></p>} />}
                            {statusDeatial['等待模板初始化'] && <FormControlLabel value="等待模板初始化" control={<Radio />} label={<p>等待模板初始化<span style={{color: 'red'}}>（{statusDeatial['等待模板初始化']}）</span></p>} />}
                            {statusDeatial['建站中'] && <FormControlLabel value="建站中" control={<Radio />} label={<p>建站中<span style={{color: 'red'}}>（{statusDeatial['建站中']}）</span></p>} />}
                            {statusDeatial['发送邮件中'] && <FormControlLabel value="发送邮件中" control={<Radio />} label={<p>发送邮件中<span style={{color: 'red'}}>（{statusDeatial['发送邮件中']}）</span></p>} />}
                            {statusDeatial['等待装修'] && <FormControlLabel value="等待装修" control={<Radio />} label={<p>等待装修<span style={{color: 'red'}}>（{statusDeatial['等待装修']}）</span></p>} />}
                            {statusDeatial['装修中'] && <FormControlLabel value="装修中" control={<Radio />} label={<p>装修中<span style={{color: 'red'}}>（{statusDeatial['装修中']}）</span></p>} />}
                            {statusDeatial['等待验收'] && <FormControlLabel value="等待验收" control={<Radio />} label={<p>等待验收<span style={{color: 'red'}}>（{statusDeatial['等待验收']}）</span></p>} />}
                            {statusDeatial['等待交付'] && <FormControlLabel value="等待交付" control={<Radio />} label={<p>等待交付<span style={{color: 'red'}}>（{statusDeatial['等待交付']}）</span></p>} />}
                            {statusDeatial['等待域名解析'] && <FormControlLabel value="等待域名解析" control={<Radio />} label={<p>等待域名解析<span style={{color: 'red'}}>（{statusDeatial['等待域名解析']}）</span></p>} />}
                            {statusDeatial['域名解析中'] && <FormControlLabel value="域名解析中" control={<Radio />} label={<p>域名解析中<span style={{color: 'red'}}>（{statusDeatial['域名解析中']}）</span></p>} />}
                            {statusDeatial['等待域名所有人变更'] && <FormControlLabel value="等待域名所有人变更" control={<Radio />} label={<p>等待域名所有人变更<span style={{color: 'red'}}>（{statusDeatial['等待域名所有人变更']}）</span></p>} />}
                            {statusDeatial['装修对接中'] && <FormControlLabel value="装修对接中" control={<Radio />} label={<p>装修对接中<span style={{color: 'red'}}>（{statusDeatial['装修对接中']}）</span></p>} />}
                            {statusDeatial['完成'] && <FormControlLabel value="完成" control={<Radio />} label={<p>完成<span style={{color: 'red'}}>（{statusDeatial['完成']}）</span></p>} />}
                            {statusDeatial['退款中'] && <FormControlLabel value="退款中" control={<Radio />} label={<p>退款中<span style={{color: 'red'}}>（{statusDeatial['退款中']}）</span></p>} />}
                            {statusDeatial['退款审核'] && <FormControlLabel value="退款审核" control={<Radio />} label={<p>退款审核<span style={{color: 'red'}}>（{statusDeatial['退款审核']}）</span></p>} />}
                            {statusDeatial['退款完成'] && <FormControlLabel value="退款完成" control={<Radio />} label={<p>退款完成<span style={{color: 'red'}}>（{statusDeatial['退款完成']}）</span></p>} />}
                            {statusDeatial['过期未开发'] && <FormControlLabel value="过期未开发" control={<Radio />} label={<p>过期未开发<span style={{color: 'red'}}>（{statusDeatial['过期未开发']}）</span></p>} />}
                            {statusDeatial['错误'] && <FormControlLabel value="错误" control={<Radio />} label={<p>错误<span style={{color: 'red'}}>（{statusDeatial['错误']}）</span></p>} />}
                        </RadioGroup>
                    </FormControl>
                    <TextField
                        select
                        label={"是否提供资料"}
                        style={{ width: 150}}
                        value={query.customerInfoAttachmentUrl}
                        margin="normal"
                        onChange={(e) => this.changeQuery(e, 'customerInfoAttachmentUrl')}
                    >
                        <MenuItem value={'isnotnull'} key={'是'}>是</MenuItem>
                        <MenuItem value={'isnull'} key={'否'}>否</MenuItem>
                    </TextField>
                    <TextField
                        select
                        label={"排序"}
                        style={{ width: 150, marginLeft: 20 }}
                        value={page.sort}
                        margin="normal"
                        onChange={(e)=>this.onSortClick(e.target.value)}
                    >
                        {[{name: '按创建日期倒序', value: 'createTime,desc'}, {name: '按交付日期正序', value: 'decorationEndTime'}].map((item,index) => {
                            return <MenuItem value={item.value} key={index}>{item.name}</MenuItem>
                        })}
                    </TextField>
                    <TextField
                        select
                        label={"技术人员"}
                        style={{ width: 150, marginLeft: 20}}
                        value={query.currentAccountName}
                        margin="normal"
                        onChange={(e) => this.changeQuery(e, 'currentAccountName')}
                    >
                        <MenuItem value={''} key={-1}>全部</MenuItem>
                        {techs.map((item,index) => {
                            return <MenuItem value={item.name} key={index}>{item.name}</MenuItem>
                        })}
                    </TextField>
                    <TextField
                        select
                        label={"售后人员"}
                        style={{ width: 150, marginLeft: 20}}
                        value={query.afterSalerName}
                        margin="normal"
                        onChange={(e) => this.changeQuery(e, 'afterSalerName')}
                    >
                        <MenuItem value={''} key={-1}>全部</MenuItem>
                        {afters.map((item,index) => {
                            return <MenuItem value={item.name} key={index}>{item.name}</MenuItem>
                        })}
                    </TextField>
                    {(http.isRoot() || http.isShouQianRole() || http.isJuan()) && <TextField
                        select
                        label={"是否退款域名"}
                        style={{ width: 150, marginLeft: 20}}
                        value={query.isRefundDomain}
                        margin="normal"
                        onChange={(e) => {
                            if (e.target.value === false) {
                                dispatch({type: actions.CHANGE_QUERY,key: 'isNeedBuyDomain',value: true})
                                dispatch({type: actions.CHANGE_QUERY,key: 'status',value: '退款完成'})
                            }
                            this.changeQuery(e, 'isRefundDomain')
                        }}
                    >
                        <MenuItem value={''} key={-1}>全部</MenuItem>
                        <MenuItem value={true} key={0}>是</MenuItem>
                        <MenuItem value={false} key={1}>否</MenuItem>
                    </TextField>}
                </Grid>
                <Paper className={classes.root}>
                    {list.length === 0 && <NoData />}
                    {list.length > 0 && <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.tableCell}>客户信息</TableCell>
                                <TableCell className={classes.tableCell}>订单信息</TableCell>
                                <TableCell className={classes.tableCell}>状态</TableCell>
                                <TableCell className={classes.tableCell}>后台信息</TableCell>
                                <TableCell>操作</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.map(row => {
                                const techAccount = techs.find(item => item.name === row.currentAccountName);
                                const afterAccount = afters.find(item => item.name === row.afterSalerName);
                                const workCopyTechs = techs.filter(item => (!(item.workStatus === '请假' && item.workLeaveEndTime > Date.now() && item.workLeaveStartTime < Date.now())) && item.accountRoles.some(role => role.roleName === '模版技术'));
                                const workCopyAfters = techs.filter(item => (!(item.workStatus === '请假' && item.workLeaveEndTime > Date.now() && item.workLeaveStartTime < Date.now())) && item.accountRoles.some(role => role.roleName === '模版对接'));
                                let is_tech_leave = false;
                                let tech_jiaojie_account = null;
                                let is_after_leave = false;
                                let after_jiaogeiwo_account = null;
                                if (techAccount) {
                                    if (techAccount.workStatus === '请假' && techAccount.workLeaveEndTime > Date.now() && techAccount.workLeaveStartTime < Date.now()) {
                                        is_tech_leave = true;
                                        tech_jiaojie_account = workCopyTechs[row.id % workCopyTechs.length];
                                    }
                                } else { // 离职
                                    is_tech_leave = true;
                                    tech_jiaojie_account = workCopyTechs[row.id % workCopyTechs.length];
                                }
                                if (afterAccount) {
                                    if (afterAccount.workStatus === '请假' && afterAccount.workLeaveEndTime > Date.now() && afterAccount.workLeaveStartTime < Date.now()) {
                                        is_after_leave = true;
                                        after_jiaogeiwo_account = workCopyAfters[row.id % workCopyAfters.length];
                                    }
                                } else { // 离职
                                    is_after_leave = true;
                                    after_jiaogeiwo_account = workCopyAfters[row.id % workCopyAfters.length];
                                }

                                return (
                                    <TableRow key={row.id}>
                                        <TableCell className={classes.tableCell}>
                                            <p>
                                                ID: Z{row.id}
                                                <CopyToClipboard text={`Z${row.id}-${row.customerAdminName}`} onCopy={() => dispatch(tip.success('复制成功'))}>
                                                    <IconButton style={{verticalAlign: "middle", width: 20,height: 20, marginLeft: 10}}><ContentCopy /></IconButton>
                                                </CopyToClipboard>
                                            </p>
                                            <p>
                                                来源: {(referDomains.find(item => item.value === row.referDomain) || {name: '-'}).name}
                                                {/* <span style={{fontSize: 12, paddingLeft: 4, color: 'rgba(0, 0, 0, 0.7)'}}>({row.paymentMethod})</span> */}
                                            </p>
                                            <p>旺旺号: {row.aliwangwang}</p>
                                            <p>手机号: {row.phone}</p>
                                            <p>
                                                邮箱: {row.email}
                                                {row.email && <CopyToClipboard text={row.email} onCopy={() => dispatch(tip.success('复制成功'))}>
                                                    <IconButton style={{verticalAlign: "middle", width: 16,height: 16, marginLeft: 8}}><ContentCopy /></IconButton>
                                                </CopyToClipboard>}
                                            </p>
                                            <p>公司名称: {row.companyName}</p>
                                            <p>
                                                客户域名: {row.domain ? <a href={`http://www.${row.domain}`} target="_blank">{row.domain}</a> : '-'}
                                                {row.domain && <CopyToClipboard text={row.domain} onCopy={() => dispatch(tip.success('复制成功'))}>
                                                    <IconButton style={{verticalAlign: "middle", width: 16,height: 16, marginLeft: 8}}><ContentCopy /></IconButton>
                                                </CopyToClipboard>}
                                                {(row.customerAdminName && row.domain && row.status === '完成') && <a href="javascript:;" style={{paddingLeft: 8}} onClick={() => this.domainTest(row)}>访问诊断</a>}
                                            </p>
                                            {(row.customerAdminName && row.domain) &&<p>
                                                域名来源: {row.isNeedBuyDomain ? '我们注册' : '客户自备'}
                                                {row.isNeedBuyDomain && <CopyToClipboard text={`域名控制面板地址： http://dnsmsn.com/\n\n域名：${row.domain}\n\n密码：${row.domain.substring(0, row.domain.indexOf('.')).substring(0, 1).toUpperCase() + row.domain.substring(0, row.domain.indexOf('.')).substring(1)}01`} onCopy={() => dispatch(tip.success('复制成功'))}>
                                                    <IconButton style={{verticalAlign: "middle", width: 16,height: 16, marginLeft: 8}}><ContentCopy /></IconButton>
                                                </CopyToClipboard>}
                                                {row.isNeedBuyDomain && <a href={`http://zqxfd.kaixinjianzhan.com/article_772.html`} target="_blank" style={{marginLeft: 8}}>域名转移教程</a>}
                                            </p>}
                                            {row.domainCard && <p>域名证书: <a href={row.domainCard} target="_blank" download={`${row.domain}的证书.jpg`}>下载</a></p>}
                                            {row.cidType && <p>证件类型: {row.cidType}</p>}
                                            {row.attachmentUrl && <p>客户证件: <a href={`${row.attachmentUrl}`} target="_blank">查看</a></p>}
                                            {row.customerAdminName && <p>
                                                {(row.restOrderMoney === 0) && <Link
                                                    to={{
                                                        pathname: "/order-domain",
                                                        search: `?${qs.stringify({
                                                            opt: 'add',
                                                            aliwangwang: row.aliwangwang,
                                                            phone: row.phone,
                                                            email: row.email,
                                                            domain: row.domain,
                                                            buyYear: row.buyYear,
                                                            domainMoney: row.domainMoney,
                                                            cidType: row.cidType,
                                                            attachmentUrl: row.attachmentUrl,
                                                            from: 'order-my',
                                                            orderId: row.id
                                                        })}`,
                                                    }}
                                                >注册域名</Link>}
                                                <Link
                                                    style={{paddingLeft: 8}}
                                                    to={{
                                                        pathname: "/order-renew",
                                                        search: `?${qs.stringify({
                                                            opt: 'add',
                                                            type: '仿站订单',
                                                            orderName: row.customerAdminName,
                                                        })}`,
                                                    }}
                                                >新增续费</Link><br/>
                                                <a style={{paddingTop: 4, display: 'inline-block'}} href={`javascript:;`} onClick={()=>dispatch(actions.addSon(row))}>新增子订单</a>
                                                {/* <a href="" style={{paddingLeft: 8}}>新增备案</a>
                                                <a href="" style={{paddingLeft: 8}}>安装证书</a><br/>
                                                <a href="">加需求补差价</a>
                                                <a href="" style={{paddingLeft: 8}}>新增续费</a> */}
                                            </p>}
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            <p>模板编号: <a href={`http://${row.templateNumber}.template.caihongjianzhan.com`} target="_blank">{row.templateNumber}</a></p>
                                            <p>订单金额: {row.orderMoney}{row.restOrderMoney > 0 ? <span style={{fontSize: 12, paddingLeft: 4, color: 'rgba(0, 0, 0, 0.7)'}}>(剩余尾款: {row.restOrderMoney})</span> : ''}</p>
                                            <p>购买年限: {row.buyYear}</p>
                                            <p>下单日期: {dateFormat(new Date(row.orderTime))}</p>
                                            <p>网站标签: {row.labels || '-'}</p>
                                            <p>是否案例: {row.anliIsTuijian ? '是' : '否'}{row.customerAdminName && <a style={{paddingLeft: 4}} href={`javascript:;`} onClick={()=>dispatch(actions.showKeywordModal(row.id))}>关键词</a>}</p>
                                            {row.contractUrl && <p>合同链接: <a href={row.contractUrl} target="_blank">查看</a></p>}
                                            {row.invoiceUrl && <p>发票链接: <a href={row.invoiceUrl} target="_blank">查看</a></p>}
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            {row.status.indexOf('退款') !== -1 ? 
                                                <p style={{color: '#f50057'}}>订单状态: <ErrorIcon color="secondary" style={{verticalAlign: 'bottom', fontSize: 17}} /> {this.renderStatus(row)}</p>
                                                : <p>订单状态: {this.renderStatus(row)}</p>
                                            }
                                            {row.status.indexOf('退款') !== -1 && <p style={{color: '#f50057'}}>退款责任人:  {row.refundDuty || '-'}</p>}
                                            {row.status === '错误' && <p>错误原因: {row.statusMessage}</p>}
                                            {(row.customerAdminName && (http.isRoot() || http.isJuan())) && <p>
                                                <a href={`javascript:;`} onClick={()=>dispatch(actions.stopStartWangZhan(row, 'stop'))}>网站关闭</a>
                                                <a style={{paddingLeft: 16}} href={`javascript:;`} onClick={()=>dispatch(actions.stopStartWangZhan(row, 'start'))}>网站开启</a>
                                            </p>}
                                            <p>是否软件自动: {row.isAuto ? '是' : '否'}</p>
                                            <p style={{color: row.isOverdue ? '#f50057' : 'unset'}}>是否逾期: {this.renderOverdue(row)}</p>
                                            <p>创建人: {row.accountName}</p>
                                            <p>创建日期: {dateFormat(new Date(row.createTime))}</p>
                                            {(!row.customerInfoAttachmentUrl) && <p>客户未提供装修资料</p>}
                                            {((row.customerInfoAttachmentUrl || baseInfo[row.customerAdminName])) && 
                                                <p style={{color: (((new Date(row.decorationEndTime) - Date.now()) < 86400000) && row.status.indexOf('装修') !== -1) ? '#ff3860' : 'rgba(0, 0, 0, 0.87)', fontWeight: (((new Date(row.decorationEndTime) - Date.now()) < 86400000) && row.status.indexOf('装修') !== -1) ? 700 : 400}}>
                                                    装修交付日期: {dateFormat(new Date(row.decorationEndTime))} {!(http.isTechRole() || http.isTechShouHouRole()) && this.renderChangeJiaofuTime(row)}
                                            </p>}
                                            {row.customerAdminName && <p>客户基本信息: <a href={`http://www.kaixinjianzhan.com/a/?name=${row.customerAdminName}&domain=${row.domainCnameValue}`} target="_blank">查看</a>{baseInfo[row.customerAdminName] && <span style={{color: '#f50057',fontSize: 12, paddingLeft: 4}}>{moment(baseInfo[row.customerAdminName].update_time).fromNow()}</span>}</p>}
                                            {(row.customerInfoAttachmentUrl) && <p>客户资料附件: <a href={row.customerInfoAttachmentUrl} target="_blank" download={`${row.customerInfoAttachmentUrl.substring(row.customerInfoAttachmentUrl.lastIndexOf('/') + 1)}`}>下载</a></p>}
                                            {row.codingRemarks && <p style={{border: 'rgb(245, 0, 87) solid 1px', padding: 8, maxWidth: 200, wordBreak: 'break-word'}}><strong>开发备注:</strong> <br /> <span dangerouslySetInnerHTML={{__html: (row.codingRemarks || '').split('\n').join('<br>')}}></span></p>}
                                            {((http.isRoot() || http.isTechRole()) && row.customerAdminName) && <p><a href={`javascript:;`} onClick={()=>dispatch(actions.showTranslateModal(row.id))}>翻译</a></p>}
                                            {((http.isRoot() || http.isTechRole()) && row.customerAdminName) && <p><a href={`javascript:;`} onClick={()=>dispatch(actions.showAdminModal(row.id))}>初始化定制后台</a></p>}
                                            {row.customerAdminName && <p>
                                                <CopyToClipboard text={http.getDuijieTiGongZiLiao(row)}  onCopy={() => dispatch(tip.success('复制成功'))}>
                                                    <a href={`javascript:;`}>对接一键复制让客户提供资料</a>
                                                </CopyToClipboard>
                                            </p>}
                                            <p>
                                                <CopyToClipboard text={http.getDuijieJiaoFuRiQi(row)}  onCopy={() => dispatch(tip.success('复制成功'))}>
                                                    <a href={`javascript:;`}>对接一键复制跟客户确认交付时间</a>
                                                </CopyToClipboard>
                                            </p>
                                            {row.customerAdminName && <p><a href={`http://test.xuansiwei.com:8000/njs/code/analyze-result/${row.customerAdminName}?tempDomain=${row.customerTempDomain}`} target="_blank">网站验收检查</a></p>}
                                            {row.status === '完成' && (http.isRoot() || http.isShouQianRole() || http.isJuan()) && <p><a href={`http://${(row.customerAdminUrl || '').replace(row.customerAdminName + '.', '')}/api/download/${row.customerAdminName}`} target="_blank">源码下载</a></p>}
                                            {row.status === '完成' && (http.isRoot() || http.isJuan()) && <p><a href={`http://${(row.customerAdminUrl || '').replace(row.customerAdminName + '.', '')}/api/download/${row.customerAdminName}?has_img=1`} target="_blank">源码下载带图片</a></p>}
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            {row.customerTempDomain && <p>访问二级域名: <a href={`http://${row.customerTempDomain}`} target="_blank">{row.customerTempDomain}</a></p>}
                                            {row.currentAccountName && <p>
                                                开发专员: 
                                                <a href={`http://wpa.qq.com/msgrd?v=3&uin=${techAccount ? techAccount.qq : '345892572'}&site=qq&menu=yes`} target="_blank" rel="noopener noreferrer" style={{color: is_tech_leave ? 'gray' : 'unset'}}>{row.currentAccountName}</a>
                                                {is_tech_leave ? <span>&nbsp;&nbsp;(代办人: <a href={`http://wpa.qq.com/msgrd?v=3&uin=${tech_jiaojie_account ? tech_jiaojie_account.qq : '345892572'}&site=qq&menu=yes`} target="_blank" rel="noopener noreferrer">{tech_jiaojie_account ? tech_jiaojie_account.name : 'admin'}</a>)</span> : ''}
                                                {http.isRoot() && this.renderChangeTech(row)}
                                            </p>}
                                            {row.afterSalerName && <p>
                                                对接专员: 
                                                <a href={`http://wpa.qq.com/msgrd?v=3&uin=${afterAccount ? afterAccount.qq : '345892572'}&site=qq&menu=yes`} target="_blank" rel="noopener noreferrer" style={{color: is_after_leave ? 'gray' : 'unset'}}>{row.afterSalerName}</a>
                                                {is_after_leave ? <span>&nbsp;&nbsp;(代办人: <a href={`http://wpa.qq.com/msgrd?v=3&uin=${after_jiaogeiwo_account ? after_jiaogeiwo_account.qq : '345892572'}&site=qq&menu=yes`} target="_blank" rel="noopener noreferrer">{after_jiaogeiwo_account ? after_jiaogeiwo_account.name : 'admin'}</a>)</span> : ''}
                                                {(http.isRoot() || http.isShouQianRole()) && this.renderChangeAfter(row)}
                                            </p>}
                                            {row.gitUrl && <p>
                                                仓库地址: {row.gitUrl}
                                                    <CopyToClipboard text={row.gitUrl} onCopy={() => dispatch(tip.success('复制成功'))}>
                                                        <IconButton style={{verticalAlign: "middle", width: 20,height: 20, marginLeft: 10}}><ContentCopy /></IconButton>
                                                    </CopyToClipboard>
                                            </p>}
                                            {row.customerAdminUrl && <p>
                                                后台入口: <a href={`http://${row.customerAdminUrl}?name=${row.customerAdminName}&password=${row.customerAdminPassword}`} target="_blank">点击登录</a>
                                                    <CopyToClipboard text={row.customerAdminUrl} onCopy={() => dispatch(tip.success('复制成功'))}>
                                                        <IconButton style={{verticalAlign: "middle", width: 20,height: 20, marginLeft: 10}}><ContentCopy /></IconButton>
                                                    </CopyToClipboard>
                                            </p>}
                                            {row.customerAdminName && <p>
                                                用户名: {row.customerAdminName}
                                                    <CopyToClipboard text={row.customerAdminName} onCopy={() => dispatch(tip.success('复制成功'))}>
                                                        <IconButton style={{verticalAlign: "middle", width: 20,height: 20, marginLeft: 10}}><ContentCopy /></IconButton>
                                                    </CopyToClipboard>
                                            </p>}
                                            {row.customerAdminPassword && <p>
                                                密码: {row.customerAdminPassword}
                                                    <CopyToClipboard text={row.customerAdminPassword} onCopy={() => dispatch(tip.success('复制成功'))}>
                                                        <IconButton style={{verticalAlign: "middle", width: 20,height: 20, marginLeft: 10}}><ContentCopy /></IconButton>
                                                    </CopyToClipboard>
                                            </p>}
                                            {row.customerAdminName && <p>
                                                <CopyToClipboard text={`后台登陆地址: ${row.customerAdminUrl}\n后台用户名: ${row.customerAdminName}\n后台密码: ${row.customerAdminPassword}\n预览网站，登陆管理后台点击右上角预览即可。`}  onCopy={() => dispatch(tip.success('复制成功'))}>
                                                    <a href={`javascript:;`}>一键复制客户信息</a>
                                                </CopyToClipboard>
                                            </p>}
                                            {(row.customerAdminName && (http.isShouQianRole() || http.isRoot()))&& <p>
                                                <CopyToClipboard text={http.getMyShouqianJiaofuxinxi(row)}  onCopy={() => dispatch(tip.success('复制成功'))}>
                                                    <a href={`javascript:;`}>售前一键复制交付信息</a>
                                                </CopyToClipboard>
                                            </p>}
                                            {(row.customerAdminName && !http.isShouQianRole())&& <p>
                                                <CopyToClipboard text={http.getMyShouqianJiaofuxinxi(row)}  onCopy={() => dispatch(tip.success('复制成功'))}>
                                                    <a href={`javascript:;`}>对接一键复制交付信息</a>
                                                </CopyToClipboard>
                                            </p>}
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            {permissionMap['模板建站订单_查询'] && <a href={`javascript:;`} onClick={()=>dispatch(actions.showUpdateModal(row.id, true))}>查看详情</a>}<br/><br/>
                                            {permissionMap['模板建站订单_修改'] && <a href={`javascript:;`} onClick={()=>dispatch(actions.showUpdateModal(row.id, false))}>修改</a>}<br/><br/>
                                            {/* {permissionMap['模板建站订单_删除'] && <a href={`javascript:;`} onClick={()=>dispatch({type: actions.SHOW_MODAL,key: 'delete', id: row.id})}>删除</a>}<br/><br/> */}
                                            {(permissionMap['模板建站订单_退款'] && row.customerAdminName) && <div><a href={`javascript:;`} onClick={()=>dispatch(actions.showRefundModal(row.id))}>退款</a><br/><br/></div>}
                                            {(permissionMap['模板建站订单_修改'] && row.customerAdminName) && <div><a href={`javascript:;`} onClick={()=>row.restOrderMoney > 0 ? dispatch(tip.error('客户付完尾款后才能上线')) : dispatch(actions.showFtpModal(row.id))}>上线</a><br/><br/></div>}
                                            {(permissionMap['模板建站订单_修改'] && row.customerAdminName) && <div><a href={`javascript:;`} onClick={()=>dispatch(actions.showSslModal(row.id))}>安装SSL</a><br/><br/></div>}
                                            {(permissionMap['仿站订单_修改'] && row.customerAdminName && (http.isRoot() || http.isJuan())) && <div><a href={`javascript:;`} onClick={()=>dispatch(actions.showTempModal(row.id))}>更换域名后缀</a><br/><br/></div>}
                                            {permissionMap['模板建站订单_查询'] && <div><a href={`javascript:;`} onClick={()=>dispatch(actions.showFlowModal(row.id, true))}>查看订单流程</a><br/><br/></div>}
                                            {((http.isRoot() || http.isJuan()) && row.customerAdminName) && <div><a href={`javascript:;`} onClick={()=>dispatch(actions.showDelayModal(row.id))}>延长网站到期日期</a><br/><br/></div>}
                                            {((http.isRoot() || http.isJuan()) && row.customerAdminName) && <div><a href={`javascript:;`} onClick={()=>dispatch(actions.showSmsModal(row.id))}>分配短信验证码</a></div>}
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                        <TableFooter>
                            <Pagination 
                                total={total}
                                {...page}
                                onPageClick={this.onPageClick}
                            />
                        </TableFooter>
                    </Table>}
                </Paper>
                {showModal.add && <AddFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.add(formData))}/>}
                {showModal.son && <SonFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.add(formData))}/>}
                {showModal.update && <UpdateFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.update(formData))} />}
                {showModal.delete && <DeleteDialog {...this.props} />}
                {showModal.refund && <RefundFormDialog {...this.props} onSubmit={(formData)=>{dispatch(actions.update(formData)); dispatch(actions.stopStartWangZhan(formData, 'stop'))}} />}
                {showModal.ftp && <FtpFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.updateFtp(formData))} />}
                {showModal.ssl && <SslFormDialog {...this.props} />}
                {showModal.temp && <TempFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.updateTemp(formData))} />}
                {showModal.translate && <TranslateFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.updateTranslate(formData))} />}
                {showModal.admin && <AdminFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.updateAdmin(formData))} />}
                {showModal.delay && <DelayFormDialog {...this.props} />}
                {showModal.sms && <SmsFormDialog {...this.props} />}
                {showModal.flow && <FlowDialog {...this.props} />}
                {showModal.keyword && <KeywordFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.updateKeyword(formData))} />}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.orderMy,
        befores: state.orderCopy.befores,
        techs: state.orderCopy.techs,
        afters: state.orderCopy.afters,
        permissionMap: state.auth.user.permissionMap
    }
}

export default connect(mapStateToProps)(withStyles(styles)(OrderMy))


// WEBPACK FOOTER //
// ./src/pages/home/routes/order_my/components/list.js